import { Button, Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import type { PollWrapperSchema } from "../types";

export const PollFormNonCustomAnswerPreview: FC = () => {
  const { control, getValues } = useFormContext<PollWrapperSchema>();
  useWatch({ control, name: ["poll.options", "poll.helper_text"] });
  const [options, helper_text] = getValues(["poll.options", "poll.helper_text"]);

  return (
    <Stack direction="column" spacing={1}>
      <Typography variant="caption" color="textSecondary" gutterBottom>
        PREVIEW
      </Typography>
      <Stack
        direction="row"
        spacing={0}
        sx={{ border: "1px solid #D1D5DB", borderRadius: 1, overflow: "hidden" }}
      >
        {options.map(({ text }, index) => (
          <Button
            variant="outlined"
            fullWidth
            sx={{
              flex: 1,
              borderRadius: 0,
              borderLeft: index !== 0 ? "1px solid #ccc" : "none",
              borderTop: "none",
              borderBottom: "none",
              borderRight: "none",
              textTransform: "none",
              color: "#121828",
              backgroundColor: "#ffffff",
            }}
            data-analytics-id={`poll-answer-option-${text}`}
            key={`poll-answer-option-${text}`}
          >
            {text}
          </Button>
        ))}
      </Stack>
      {helper_text && <Typography sx={{ fontSize: "0.8em" }}>{helper_text}</Typography>}
    </Stack>
  );
};
